import React from 'react';

export default function Table({ list1 }) {
  if (!list1.length) {
    return null; // return null or some message if list1 is empty
  }

  // Get the headers from the keys of the first item in the list, excluding 'id'
  const headers = Object.keys(list1[0]).filter(header => header !== 'id');

  return (
    <section
      className="services-area bg-white pb-120 wow fadeInUp"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <div className="container">
        <div className="section-title mb-45">
          <div className="table-responsive">
            <table className="table table-borderless mb-0">
              <thead>
                <tr style={{ backgroundColor: "whitesmoke" }}>
                  {headers.map((header, index) => (
                    <th className="text-center" scope="col" key={index}>
                      <h5 style={{ fontSize: "80%" }}>{header.toUpperCase()}</h5>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {list1.map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((header, colIndex) => (
                      <td
                        className="feature-item"
                        style={{ fontWeight: "normal" }}
                        key={colIndex}
                      >
                        {item[header]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
